
/**
 * @export
 * @enum {string}
 */
export enum McpLimitType {
    MCP_PREM_M = 'MCP_PREM_M',
    MCP_CORP_M = 'MCP_CORP_M'
}